import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Typography, Menu, MenuItem, IconButton } from '@mui/material';
import downloadIcon from '../../../assets/SVGs/download-icon.svg';
import { useDispatch } from 'react-redux';
import AlertDialog from '../../AlertDialog/AlertDialog';
import { UserPortalContext } from '../../../context/appcontext';
import {
	setRuleType,
	createRule,
	deleteRule,
	refreshWatchList,
	setIsCreateRuleOpen,
	getEditRuleData,
	updateSelectedItem,
	updateCompareSelectedItemA,
	updateCompareSelectedItemB,
} from '../../../redux/actions/createRuleActions';
import {
	CONFIRM_DELETE_DESCRIPTION,
	CONFIRM_DELETE_TITLE,
	DELETE,
	productFilters,
	THRESHOLD,
	COMPARISON,
	BOGLE_LIGHT,
} from '../../../constants/constant';
import analytics from '../../../helper/analytics';
import tracker from '../../../constants/tracker';

const options = ['Edit', 'De-activate', 'Delete'];

const editModal = (productHierarchyId, selection, type) => {
	const values = selection?.map((id) => {
		return {
			[productHierarchyId]: id?.id,
			checked: true,
			[productHierarchyId === 'wmUpcNbr'
				? 'upcDesc'
				: productHierarchyId?.slice(0, -2) + 'Name']: id?.value,
		};
	});
	return { [type?.toLowerCase()]: values };
};

const MenuOption = ({ data }) => {
	const dispatch = useDispatch();

	const [anchorEl, setAnchorEl] = useState(null);
	const [openAlert, setOpenAlert] = useState(false);

	const open = Boolean(anchorEl);

	const handleClose = () => setAnchorEl(null);
	const handleClick = (event) => setAnchorEl(event.currentTarget);
	const portalUserContext = useContext(UserPortalContext);

	const onItemOptionClick = (index) => {
		setAnchorEl(null);
		const rule = JSON.parse(JSON.stringify(data));
		if (index === 1) {
			if (rule.status === 'InActive') {
				//De activate Flow
				analytics.trackEventInfo({
					type: tracker.EVENTS.CLICK,
					actionOn: tracker.ACTION_ON.RULES_DEACTIVATED,
					location: `CreateRule`,
				});
			}
			if (rule.status === 'Active') {
				//Re Activate Flow
				analytics.trackEventInfo({
					type: tracker.EVENTS.CLICK,
					actionOn: tracker.ACTION_ON.RULES_REACTIVATED,
					location: `CreateRule`,
				});
				rule.status = 'InActive';
			} else {
				rule.status = 'Active';
			}
			const edit = true;
			const type = 'create';
			dispatch(refreshWatchList(true));
			dispatch(createRule({ portalUserContext, request: rule, type, edit }));
		} else if (index === 2) {
			setOpenAlert(true);
		} else {
			dispatch(setIsCreateRuleOpen(true));

			// edit for compare
			if (rule?.right) {
				const productHierarchyIdB =
					productFilters[rule?.right?.productHierarchyType];
				const editModalDataB = editModal(
					productHierarchyIdB,
					rule?.right?.productCustomFilters,
					rule?.right?.productHierarchyType
				);

				const productHierarchyIdA =
					productFilters[rule?.left?.productHierarchyType];
				const editModalDataA = editModal(
					productHierarchyIdA,
					rule?.left?.productCustomFilters,
					rule?.left?.productHierarchyType
				);
				dispatch(setRuleType(COMPARISON));
				dispatch(getEditRuleData(rule));
				dispatch(updateCompareSelectedItemA(editModalDataA));
				dispatch(updateCompareSelectedItemB(editModalDataB));
			} else {
				// edit for threshold
				const productHierarchyId =
					productFilters[rule?.left?.productHierarchyType];
				const editModalData = editModal(
					productHierarchyId,
					rule?.left?.productCustomFilters,
					rule?.left?.productHierarchyType
				);

				dispatch(getEditRuleData(rule));
				dispatch(updateSelectedItem(editModalData));
				dispatch(setRuleType(THRESHOLD));
			}

			if (
				rule?.left?.locationFilters?.length > 0 &&
				rule?.left?.location === 'STORES'
			) {
				const storeEditData = editModal(
					'storeId',
					rule?.left?.locationCustomFilters,
					'STORE'
				);

				dispatch(updateSelectedItem(storeEditData));
				dispatch(updateCompareSelectedItemA(storeEditData));
			}

			if (
				rule?.right?.locationFilters?.length > 0 &&
				rule?.right?.location === 'STORES'
			) {
				const storeEditData = editModal(
					'storeId',
					rule?.right?.locationCustomFilters,
					'STORE'
				);
				dispatch(updateCompareSelectedItemB(storeEditData));
			}
		}
	};

	function ruleDeleteHandler() {
		const id = data.id;
		dispatch(deleteRule({ portalUserContext, id }));
		setOpenAlert(false);
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: tracker.ACTION_ON.RULES_DELETED,
			location: `CreateRule`,
		});
	}

	return (
		<Typography>
			<IconButton
				aria-label="more"
				id="long-button"
				aria-controls={open ? 'long-menu' : undefined}
				aria-expanded={open ? 'true' : undefined}
				aria-haspopup="true"
				onClick={handleClick}>
				<img alt="Download" src={downloadIcon} />
			</IconButton>

			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				disableEnforceFocus
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center',
				}}
				PaperProps={{
					style: {
						marginTop: '5px',
						boxShadow: '1px 1px 2px #ccc',
					},
				}}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}>
				{options?.map((option, index) => (
					<MenuItem
						id={`menuItem${option}`}
						key={`menu-item-${index}`}
						style={{ display: 'block', padding: '10px' }}
						sx={{
							fontFamily: BOGLE_LIGHT,
							fontSize: 14,
						}}
						disabled={data.status === 'InActive' && index === 0}
						onClick={() => onItemOptionClick(index)}>
						{data.status === 'InActive' && index === 1 ? 'Re-activate' : option}
					</MenuItem>
				))}
			</Menu>
			{openAlert && (
				<AlertDialog
					title={CONFIRM_DELETE_TITLE}
					description={CONFIRM_DELETE_DESCRIPTION}
					alertCloseHandler={setOpenAlert}
					option={DELETE}
					data={data}
					optionClickHandler={ruleDeleteHandler}
				/>
			)}
		</Typography>
	);
};

MenuOption.propTypes = {
	data: PropTypes.object,
};

export default MenuOption;
